import React, { useState } from "react"
import Box from "@material-ui/core/Box"
import Checkbox from "components/Forms/Checkbox"

/** Styles */
import styles from "./styles"

interface Props {
  handleUpdate: Function
  data: any
}

const Announcement: React.FC<Props> = ({ handleUpdate, data }) => {
  const { category, section } = styles()
  const [title] = useState("VMS/Deliveries")

  return (
    <Box display="flex" alignItems="center" className={section}>
      <Box flex="3" className={category}>
        {title}
      </Box>
      <Box flex="1">
        {/* Create */}
        <Checkbox
          label={null}
          value={Boolean(data?.vms_delivery_edit)}
          onChange={() =>
            handleUpdate("vms_delivery_edit", Boolean(!data?.vms_delivery_edit))}
        />
      </Box>
      <Box flex="1">
        {/* Update */}
        <Checkbox
          label={null}
          value={Boolean(data?.vms_delivery_view)}
          onChange={() =>
            handleUpdate("vms_delivery_view", Boolean(!data?.vms_delivery_view))}
        />
      </Box>
    </Box>
  )
}
export default Announcement
